import { SearchFilters } from '../search/schemas'
import { assign, createMachine, Interpreter, State } from 'xstate'
import { PopularLocation } from './types'

interface Schema {
  states: {
    idle: {}
    loading: {}
    success: {}
    failure: {}
  }
}

interface Events {
  type: 'FETCH'
  searchFilters: SearchFilters
}

interface Context {
  locations: PopularLocation[]
  searchFilters: SearchFilters | null
}

export function returnPopularLocationsMachine() {
  return createMachine<Context, Events>(
    {
      id: 'popular-locations',
      context: {
        locations: [],
        searchFilters: null,
      },
      initial: 'idle',
      states: {
        idle: {
          on: {
            FETCH: {
              actions: assign({
                searchFilters: (_, { searchFilters }) => searchFilters,
              }),
              target: 'loading',
            },
          },
        },
        loading: {
          invoke: {
            src: 'fetch',
            onDone: {
              target: 'success',
              actions: assign({
                locations: (_, { data }) => data,
              }),
            },
            onError: {
              target: 'failure',
              actions: 'logError',
            },
          },
        },
        success: {
          type: 'final',
        },
        failure: {
          type: 'final',
        },
      },
    },
    {
      services: {
        fetch: () => {
          throw new Error('fetch not implemented')
        },
      },
      actions: {
        logError: () => {
          throw new Error('popularLocationsMachine logError not implemented')
        },
      },
    },
  )
}

export type PopularLocationsMachineInterpreter = Interpreter<
Context,
Schema,
Events
>

export type PopularLocationsMachineState = State<Context, Events>
